module.exports = __webpack_public_path__ + "static/media/7.f7b13e08.png";